/* Collection switcher shelf: tabs switch panels, pills filter the active panel's .gg-shelf. */
if (!customElements.get('gg-collection-shelf')) {
  customElements.define(
    'gg-collection-shelf',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.pills = Array.from(this.querySelectorAll('[data-pill]'));
        this.pill = '';

        this.addEventListener('click', (e) => {
          const tab = e.target.closest('[role="tab"]');
          const pill = e.target.closest('[data-pill]');
          if (tab) this.select(tab);
          if (pill) {
            this.pill = pill.dataset.pill;
            this.apply();
          }
        });

        // Arrow keys move between tabs (WAI-ARIA tabs pattern).
        this.addEventListener('keydown', (e) => {
          const i = this.tabs.indexOf(e.target);
          if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
          this.select(next);
          next.focus();
        });

        // Theme editor: selecting a tab block shows that tab.
        this.addEventListener('shopify:block:select', (e) => {
          if (this.tabs.includes(e.target)) this.select(e.target);
        });
      }

      select(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
        });
        this.apply();
      }

      apply() {
        this.pills.forEach((p) => p.setAttribute('aria-pressed', p.dataset.pill === this.pill));
        const panel = this.querySelector('[role="tabpanel"]:not([hidden])');
        if (!panel || !window.ggShelf) return;
        const visible = window.ggShelf.filter(
          panel.querySelector('.gg-shelf'),
          (li) => !this.pill || li.dataset.pills.includes(` ${this.pill} `)
        );
        panel.querySelector('.gg-shelf-empty').hidden = visible > 0;
      }
    }
  );
}
